import axios from "axios";
import { apiUrl } from '../../constant';
import { FETCH_BUSINESS_LIST_SUCCESS, FETCH_CARRIER_LIST_SUCCESS, FETCH_MARKETPLACE_LIST_SUCCESS, FETCH_PRODUCT_TYPE_LIST_SUCCESS, FETCH_USER_ONBOARDING_FAILED, FETCH_USER_ONBOARDING_PENDING, FETCH_USER_ONBOARDING_SUCCESS } from "../types";


const getAccountDetailsPending = () => ({
    type: FETCH_USER_ONBOARDING_PENDING,
});
const getAccountDetailsFailed = () => ({
    type: FETCH_USER_ONBOARDING_FAILED,
});
const getAccountDetailsSuccess = (response) => ({
    type: FETCH_USER_ONBOARDING_SUCCESS,
    payload: response,
});


export const getAccountDetails = (isViewUserRequest, data) => {
    return (dispatch) => {
        dispatch(getAccountDetailsPending());

        const query = isViewUserRequest ? '?onboardingId=' + data.Id : '';
        const url = `${apiUrl}/api/Onboarding/account-details${query}`;

        axios.get(url)
            .then((result) => {
                dispatch(getAccountDetailsSuccess(result.data.Entity));
            })
            .catch(() => {
                dispatch(getAccountDetailsFailed());
            });
    };
};

const getBusinessesListSuccess = (response) => ({
    type: FETCH_BUSINESS_LIST_SUCCESS,
    payload: response,
});

export const getBusinessesList = () => {
    return (dispatch) => {
        axios.get(`${apiUrl}/api/Onboarding/business-models`).then((result) => {
            dispatch(getBusinessesListSuccess(result.data.EntityList));
        }).catch((error) => {
            console.log(error);
        });
    };
};

const getProductTypeListSuccess = (response) => ({
    type: FETCH_PRODUCT_TYPE_LIST_SUCCESS,
    payload: response,
});


export const getProductTypeList = () => {
    return (dispatch) => {
        axios.get(`${apiUrl}/api/Onboarding/product-types`).then((result) => {
            dispatch(getProductTypeListSuccess(result.data.EntityList));
        }).catch((error) => {
            console.log(error);
        });
    };
};

const getMarketPlaceListSuccess = (response) => ({
    type: FETCH_MARKETPLACE_LIST_SUCCESS,
    payload: response,
});

export const getMarketPlaceList = () => {
    return (dispatch) => {
        axios.get(`${apiUrl}/api/Onboarding/marketplaces`).then((result) => {
            dispatch(getMarketPlaceListSuccess(result.data.EntityList));
        }).catch((error) => {
            console.log(error);
        });
    };
};

const getCarrierListSuccess = (response) => ({
    type: FETCH_CARRIER_LIST_SUCCESS,
    payload: response,
});

export const getCarrierList = () => {
    return (dispatch) => {
        axios.get(`${apiUrl}/api/Onboarding/carriers`).then((result) => {
            dispatch(getCarrierListSuccess(result.data.EntityList));
        }).catch((error) => {
            console.log(error);
        });
    };
};

export const saveAdditionalDetails = (data) => {
    return axios.post(`${apiUrl}/api/Onboarding/save-business-info`, data);
}

export const getAdditionalDetails = (userId) => {
    const query = userId ? '?onboardingId=' + userId : '';
    const url = `${apiUrl}/api/Onboarding/get-business-info${query}`;

    return axios.get(url);
};

export const getPaymentPreferencesList = () => {
    return axios.get(`${apiUrl}/api/Onboarding/payment-preferences`);
};

export const getPaymentPreferences = (userId) => {
    const query = userId ? '?onboardingId=' + userId : '';
    const url = `${apiUrl}/api/Onboarding/get-payment-setup${query}`;

    return axios.get(url);
};

export const savePaymentPreferences = (data) => {
    return axios.post(`${apiUrl}/api/Onboarding/save-payment-setup`, data);
}

export const verifySignupToken = (data) => {
    return axios.post(`${apiUrl}/api/login/verify_signup_token`, data);
}

export const getKycDetails = (data) => {
    return axios.post(`${apiUrl}/api/Onboarding/get-kyc-details`, data);
}

export const uploadKycDetails = (data) => {
    return axios.post(`${apiUrl}/api/Onboarding/upload-kyc-documents`, data);
}

export const deleteOnboardingDocument = (data) => {
    return axios.post(`${apiUrl}/api/Onboarding/delete-onboarding-document`, data);
}

export const getAgreementDetails = (data) => {
    return axios.post(`${apiUrl}/api/Onboarding/get-agreement-details`, data);
}
export const uploadAgreementDocuments = (data) => {
    return axios.post(`${apiUrl}/api/Onboarding/upload-agreement-documents`, data);
}

export const getDocumentStatusOptions = () => {
    return axios.get(`${apiUrl}/api/Onboarding/document-status-options`);
}

export const updateAgreementStatus = (data) => {
    return axios.post(`${apiUrl}/api/Onboarding/update-document-status`, data);
}

export const downloadAgreement = (data) => {
    return axios.post(`${apiUrl}/api/Onboarding/generate-document-pdf`, data);
}